import cx from 'classnames';

import { TBedrockAgentType, TFeatureConfigSchema } from '@cloud-wave/neon-common-lib';

import { useAIContext } from '../../Context';
import { TIQDisplayMode } from '../constants/IQDisplayMode';
import ActionsMenuItem from './ActionsMenuItem';
import { IQActionItems, TIQActionItem } from './constants/IQActionItems';

import styles from './iq-actions-menu.module.scss';

const getIQActionsToDisplay = ({
  IQFeaturesEnabled,
  IQFeatureConfig,
}: {
  IQFeaturesEnabled: TBedrockAgentType[];
  IQFeatureConfig: TFeatureConfigSchema['genAI'];
}) => {
  const { modes: refineEvaluateModes, evaluateEnabled } = IQFeatureConfig.AI_REFINE || {};

  const showEvaluate = IQFeaturesEnabled.includes('AI_REFINE') && refineEvaluateModes && evaluateEnabled;

  const permissionBasedItems = Object.entries(IQActionItems).reduce((previousValue, currentValue) => {
    const [permName, actionItem] = currentValue;
    const hasRequiredPermission = IQFeaturesEnabled.includes(permName as TBedrockAgentType);

    return hasRequiredPermission ? [...previousValue, actionItem] : previousValue;
  }, [] as TIQActionItem[]);

  if (showEvaluate) {
    return [IQActionItems.evaluateEnabled, ...permissionBasedItems];
  }

  return permissionBasedItems;
};

export const IQActionsMenu = ({ displayMode }: { displayMode: TIQDisplayMode }) => {
  const {
    state: { IQEnabled, IQFeaturesEnabled, IQFeatureConfig, iqInput },
  } = useAIContext();

  if (!IQEnabled) {
    return null;
  }

  const displayModeLower = displayMode.toLowerCase();
  const displayActions = getIQActionsToDisplay({ IQFeaturesEnabled, IQFeatureConfig });

  if (!displayActions?.length) {
    return null;
  }

  const buttonDisabled = !iqInput || iqInput.trim().length === 0;

  return (
    <div className={cx(styles['iq-actions-menu'], styles[`iq-actions-menu--${displayModeLower}`])}>
      {displayActions.map((item) => (
        <ActionsMenuItem key={item.actionID} item={item} displayMode={displayMode} disabled={buttonDisabled} />
      ))}
    </div>
  );
};
